import React from 'react';
import { branch, renderComponent } from 'recompose';
import PropTypes from 'prop-types';
import config from '../../config';
import { HTMLTrans } from './Translations';

const SpinnerWithoutOverlay = ({ onRef }) => {
  return (
    <div className="spinner">
      <div className='pb-spinner w-100' style={{
        background: `url(${config.s3BucketUrl}/assets/general/preloader.gif) no-repeat center center`
      }}/>
      <span className="sr-only"><HTMLTrans id="navbar.common_spinnerwithoutoverlay_loading">Loading...</HTMLTrans></span>
    </div>
  );
};
const isLoading = ({ loading }) => loading;
export const withSpinnerWithoutOverlay = branch(
  isLoading,
  renderComponent(SpinnerWithoutOverlay)
);

export default SpinnerWithoutOverlay;



// WEBPACK FOOTER //
// ./src/Common/SpinnerWithoutOverlay.js